// @flow
export const ADD_ACTION_ATTRIBUTE = 'hive/actions/ADD_ACTION_ATTRIBUTE';
export const ATTEMPT_CREATE_ACTION = 'hive/actions/ATTEMPT_CREATE_ACTION';
export const ATTEMPT_EDIT_ACTION = 'hive/actions/ATTEMPT_EDIT_ACTION';
export const ATTEMPT_REMOVE_ACTION = 'hive/actions/ATTEMPT_REMOVE_ACTION';
export const ATTEMPT_TRIGGER_QUICK_ACTION = 'hive/actions/ATTEMPT_TRIGGER_QUICK_ACTION';
export const CANCEL_FORM = 'hive/actions/CANCEL_FORM';
export const EDIT_ACTION = 'hive/actions/EDIT_ACTION';
export const END_ATTEMPT = 'hive/actions/END_ATTEMPT';
export const END_ATTEMPT_CREATE_ACTION = 'hive/actions/END_ATTEMPT_CREATE_ACTION';
export const GET_ACTIONS = 'hive/actions/GET_ACTIONS';
export const GET_TEMPLATES = 'hive/actions/GET_TEMPLATES';
export const LOAD_FORM = 'hive/actions/LOAD_FORM';
export const RECEIVE_ACTIONS = 'hive/actions/RECEIVE_ACTIONS';
export const RECEIVE_TEMPLATES = 'hive/actions/RECEIVE_TEMPLATES';
export const REMOVE_ACTION_ATTRIBUTE = 'hive/actions/REMOVE_ACTION_ATTRIBUTE';
export const REMOVE_ACTION_FROM_LIST = 'hive/actions/REMOVE_ACTION_FROM_LIST';
export const REMOVE_ACTION_FROM_DELETE_LIST = 'hive/actions/REMOVE_ACTION_FROM_DELETE_LIST';
export const RESET_QUICK_ACTION_STATUS = 'hive/actions/RESET_QUICK_ACTION_STATUS';
export const SET_ACTION_ATTRIBUTE = 'hive/actions/SET_ACTION_ATTRIBUTE';
export const SET_ACTION_FORM = 'hive/actions/SET_ACTION_FORM';
export const TRIGGER_QUICK_ACTION = 'hive/actions/TRIGGER_QUICK_ACTION';

export const IDLE = 'IDLE';
export const TRIGGERED = 'TRIGGERED';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';



// WEBPACK FOOTER //
// ./src/core/state/actions/constants.js